const eplData = [
  {
    team: 'Manchester City FC',
    crest:
      'https://upload.wikimedia.org/wikipedia/en/e/eb/Manchester_City_FC_badge.svg',
    primary: '#99C5E7',
    secondary: '#022A5D',
    points: [
      3,
      4,
      7,
      10,
      13,
      16,
      19,
      22,
      25,
      28,
      31,
      34,
      37,
      40,
      43,
      46,
      49,
      52,
      55,
      58,
      59,
      62,
      62,
      65,
      68,
      69,
      72,
      75,
      78,
      81
    ]
  },
  {
    team: 'Manchester United FC',
    crest:
      'http://upload.wikimedia.org/wikipedia/de/d/da/Manchester_United_FC.svg',
    primary: '#DC1F29',
    secondary: '#FAE935',
    points: [
      3,
      6,
      9,
      10,
      13,
      16,
      19,
      20,
      20,
      23,
      23,
      26,
      29,
      32,
      35,
      35,
      38,
      41,
      42,
      43,
      44,
      47,
      50,
      53,
      53,
      56,
      56,
      59,
      62,
      65
    ]
  },
  {
    team: 'Tottenham Hotspur FC',
    crest:
      'http://upload.wikimedia.org/wikipedia/de/b/b4/Tottenham_Hotspur.svg',
    primary: '#11214B',
    secondary: '#FFFFFF',
    points: [
      3,
      3,
      4,
      7,
      8,
      11,
      14,
      17,
      20,
      20,
      23,
      23,
      24,
      24,
      25,
      28,
      31,
      31,
      34,
      37,
      38,
      41,
      44,
      45,
      48,
      49,
      52,
      55,
      58,
      61
    ]
  },
  {
    team: 'Liverpool FC',
    crest: 'http://upload.wikimedia.org/wikipedia/de/0/0a/FC_Liverpool.svg',
    primary: '#E0202C',
    secondary: '#19A78E',
    points: [
      1,
      4,
      7,
      7,
      8,
      11,
      12,
      13,
      13,
      16,
      19,
      22,
      23,
      26,
      29,
      30,
      31,
      34,
      35,
      38,
      41,
      44,
      47,
      47,
      50,
      51,
      54,
      57,
      60,
      60
    ]
  },
  {
    team: 'Chelsea FC',
    crest: 'http://upload.wikimedia.org/wikipedia/de/5/5c/Chelsea_crest.svg',
    primary: '#034694',
    secondary: '#DBA111',
    points: [
      0,
      3,
      6,
      9,
      10,
      13,
      13,
      13,
      16,
      19,
      22,
      25,
      26,
      29,
      32,
      32,
      35,
      38,
      39,
      42,
      45,
      46,
      47,
      50,
      50,
      50,
      53,
      53,
      53,
      56
    ]
  },
  {
    team: 'Arsenal FC',
    crest: 'http://upload.wikimedia.org/wikipedia/en/5/53/Arsenal_FC.svg',
    primary: '#EC0C1C',
    secondary: '#D80919',
    points: [
      3,
      3,
      3,
      6,
      7,
      10,
      13,
      13,
      16,
      19,
      19,
      22,
      25,
      28,
      28,
      29,
      30,
      33,
      34,
      37,
      38,
      39,
      39,
      42,
      42,
      45,
      45,
      45,
      45,
      48
    ]
  },
  {
    team: 'Burnley FC',
    crest:
      'https://upload.wikimedia.org/wikipedia/en/0/02/Burnley_FC_badge.png',
    primary: '#80234C',
    secondary: '#91D2F2',
    points: [
      3,
      3,
      4,
      7,
      8,
      9,
      12,
      13,
      13,
      16,
      19,
      22,
      22,
      25,
      25,
      28,
      31,
      32,
      32,
      33,
      34,
      34,
      34,
      34,
      35,
      36,
      36,
      37,
      40,
      43
    ]
  },
  {
    team: 'Leicester City FC',
    crest: 'http://upload.wikimedia.org/wikipedia/en/6/63/Leicester02.png',
    primary: '#1358A1',
    secondary: '#FAB92C',
    points: [
      0,
      3,
      3,
      3,
      4,
      4,
      5,
      6,
      9,
      12,
      13,
      13,
      14,
      17,
      20,
      23,
      26,
      26,
      27,
      27,
      27,
      30,
      31,
      34,
      34,
      35,
      35,
      36,
      37,
      40
    ]
  },
  {
    team: 'Everton FC',
    crest: 'http://upload.wikimedia.org/wikipedia/de/f/f9/Everton_FC.svg',
    primary: '#063A99',
    secondary: '#FFFFFF',
    points: [
      3,
      4,
      4,
      4,
      4,
      7,
      7,
      8,
      8,
      8,
      11,
      12,
      12,
      15,
      18,
      19,
      22,
      25,
      26,
      27,
      27,
      27,
      27,
      28,
      31,
      31,
      34,
      34,
      34,
      37
    ]
  },
  {
    team: 'Watford FC',
    crest: 'https://upload.wikimedia.org/wikipedia/en/e/e2/Watford.svg',
    primary: '#FEEB00',
    secondary: '#E40F18',
    points: [
      1,
      4,
      5,
      8,
      8,
      11,
      12,
      15,
      15,
      15,
      15,
      18,
      21,
      21,
      22,
      22,
      22,
      22,
      22,
      25,
      25,
      25,
      26,
      26,
      27,
      30,
      30,
      33,
      36,
      36
    ]
  },
  {
    team: 'Brighton & Hove Albion',
    crest:
      'https://upload.wikimedia.org/wikipedia/en/f/fd/Brighton_&_Hove_Albion_logo.svg',
    primary: '#0A56A3',
    secondary: '#F8BC1B',
    points: [
      0,
      0,
      1,
      4,
      4,
      7,
      7,
      8,
      11,
      12,
      15,
      16,
      16,
      17,
      17,
      17,
      17,
      18,
      21,
      21,
      22,
      23,
      23,
      23,
      24,
      27,
      28,
      31,
      34,
      34
    ]
  },
  {
    team: 'AFC Bournemouth',
    crest: 'https://upload.wikimedia.org/wikipedia/de/4/41/Afc_bournemouth.svg',
    primary: '#D41E2A',
    secondary: '#000000',
    points: [
      0,
      0,
      0,
      0,
      3,
      3,
      4,
      4,
      7,
      7,
      10,
      13,
      14,
      14,
      15,
      16,
      16,
      16,
      16,
      17,
      20,
      21,
      24,
      25,
      28,
      31,
      31,
      32,
      33,
      33
    ]
  },
  {
    team: 'Newcastle United FC',
    crest:
      'http://upload.wikimedia.org/wikipedia/de/5/56/Newcastle_United_Logo.svg',
    primary: '#000000',
    secondary: '#FFFFFF',
    points: [
      0,
      0,
      3,
      6,
      9,
      9,
      10,
      11,
      14,
      14,
      14,
      14,
      14,
      15,
      15,
      15,
      15,
      15,
      18,
      18,
      19,
      22,
      23,
      23,
      24,
      25,
      28,
      29,
      29,
      32
    ]
  },
  {
    team: 'Swansea City FC',
    crest:
      'http://upload.wikimedia.org/wikipedia/de/a/ab/Swansea_City_Logo.svg',
    primary: '#121212',
    secondary: '#FFFFFF',
    points: [
      1,
      1,
      4,
      4,
      5,
      5,
      5,
      8,
      8,
      8,
      8,
      8,
      9,
      9,
      9,
      12,
      12,
      12,
      13,
      13,
      16,
      16,
      17,
      20,
      23,
      24,
      27,
      27,
      30,
      31
    ]
  },
  {
    team: 'Huddersfield Town',
    crest:
      'https://upload.wikimedia.org/wikipedia/en/5/5a/Huddersfield_Town_A.F.C._logo.svg',
    primary: '#0E63AD',
    secondary: '#FFFFFF',
    points: [
      3,
      6,
      7,
      7,
      8,
      9,
      9,
      9,
      12,
      12,
      15,
      15,
      15,
      15,
      15,
      18,
      18,
      21,
      22,
      23,
      24,
      24,
      24,
      24,
      24,
      24,
      27,
      30,
      30,
      31
    ]
  },
  {
    team: 'West Ham United FC',
    crest:
      'http://upload.wikimedia.org/wikipedia/de/e/e0/West_Ham_United_FC.svg',
    primary: '#7A263A',
    secondary: '#1BB1E7',
    points: [
      0,
      0,
      0,
      3,
      4,
      4,
      7,
      8,
      8,
      9,
      9,
      9,
      10,
      10,
      10,
      13,
      14,
      17,
      17,
      18,
      19,
      22,
      25,
      26,
      27,
      27,
      30,
      30,
      30,
      30
    ]
  },
  {
    team: 'Southampton FC',
    crest: 'http://upload.wikimedia.org/wikipedia/de/c/c9/FC_Southampton.svg',
    primary: '#D41E29',
    secondary: '#FFC20E',
    points: [
      1,
      4,
      5,
      5,
      8,
      8,
      8,
      9,
      12,
      13,
      13,
      13,
      16,
      16,
      17,
      18,
      18,
      18,
      19,
      19,
      20,
      20,
      21,
      22,
      23,
      26,
      26,
      27,
      28,
      28
    ]
  },
  {
    team: 'Crystal Palace FC',
    crest:
      'http://upload.wikimedia.org/wikipedia/de/b/bf/Crystal_Palace_F.C._logo_(2013).png',
    primary: '#1B458F',
    secondary: '#A7A5A6',
    points: [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      3,
      4,
      4,
      5,
      8,
      9,
      10,
      11,
      14,
      17,
      18,
      18,
      19,
      22,
      25,
      25,
      26,
      27,
      27,
      27,
      27,
      27
    ]
  },
  {
    team: 'Stoke City FC',
    crest: 'http://upload.wikimedia.org/wikipedia/de/a/a3/Stoke_City.svg',
    primary: '#D0122D',
    secondary: '#001F61',
    points: [
      0,
      3,
      4,
      5,
      5,
      5,
      8,
      8,
      8,
      11,
      12,
      13,
      13,
      13,
      16,
      16,
      16,
      16,
      19,
      20,
      20,
      20,
      20,
      23,
      24,
      24,
      25,
      26,
      27,
      27
    ]
  },
  {
    team: 'West Bromwich Albion FC',
    crest:
      'http://upload.wikimedia.org/wikipedia/de/8/8b/West_Bromwich_Albion.svg',
    primary: '#122F67',
    secondary: '#FFFFFF',
    points: [
      3,
      6,
      7,
      7,
      8,
      8,
      9,
      10,
      10,
      10,
      10,
      10,
      11,
      12,
      13,
      13,
      14,
      14,
      14,
      15,
      16,
      16,
      19,
      20,
      20,
      20,
      20,
      20,
      20,
      20
    ]
  }
]
export default eplData



// WEBPACK FOOTER //
// ./src/data/epl.js